import { render, staticRenderFns } from "./cv-tab.vue?vue&type=template&id=7dbcafb2&"
import script from "./cv-tab.vue?vue&type=script&lang=js&"
export * from "./cv-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports